import { PrevProjDataResponse } from "@/dashboard-api-types/api/epidemiologyData.types";

const roundOrNA = (
  value: number | undefined,
  precision: number = 0,
  nullValue: number = 0
): string => {
  if (value === undefined || value === null || value == 0) value = nullValue;
  return new Intl.NumberFormat("en-US", {
    minimumFractionDigits: precision,
    maximumFractionDigits: precision,
  }).format(Number(value));
};

export const formatPrevProjDataToTable = (data: PrevProjDataResponse["prevProjData"]) => {
  const rows: Record<string, string>[] = [];

  rows.push(
    Object.keys(data?.incidence ?? {}).reduce(
      (acc, period) => {
        acc[period] = `${period?.slice(0, 4)}-${period?.slice(7)}`;
        return acc;
      },
      { titleRow: " " } as Record<string, string>
    )
  );

  Object.entries(data ?? {}).forEach(([key, dataset]) => {
    const row: Record<string, string> = { titleRow: key };
    Object.entries(dataset).forEach(([period, changeData]) => {
      row[period] = changeData
        ? `${roundOrNA(changeData.absolute, 0)}\n(${roundOrNA(changeData.relative, 1)}%)`
        : "N/A";
    });
    rows.push(row);
  });

  return rows;
};
